import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { PageHeader } from '~/packages/common-frontend/components/PageContainer';

export const UploadView = (): React.ReactElement => {
  return (
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <PageHeader headerLabel="Upload" />
      <Box
        border="2px dashed"
        borderColor="gray.200"
        borderRadius="md"
        p="3rem"
        textAlign="center"
      >
        <Text color="gray.500">
          Drag and drop files here, or click to browse.
        </Text>
      </Box>
    </Flex>
  );
};
